<template>
  <div class="block-chart-bar" :id="title" :style="styleCustom">
    <div class="header-chart">
      <!-- <el-tooltip content="Xem thêm" placement="top"> -->
      <div
        class="flex-row flex__between"
        style="cursor: pointer"
        @click="$emit('viewMore')"
      >
        <i style="margin-right: 10px" class="fas fa-chart-bar color__white"></i>
        <span>{{ title }}</span>
        <!-- <div @click="export2image" class="btn btn-default">
          <i class="far fa-download color__smoke"></i>
        </div> -->
        <i
          class="far fa-arrow-to-right color__white font-size__large clickable"
        ></i>
      </div>
      <!-- </el-tooltip> -->
      <div class="right-action" v-if="!styleCustom">
        <!-- <div @click="fullScreen">
          <i class="fal fa-expand-arrows color__smoke"></i>
        </div> -->

        <div @click="$emit('removeItem')">
          <i class="fal fa-times color__smoke"></i>
        </div>
      </div>
    </div>
    <div class="content-chart">
      <bar-chart
        v-if="checkDisplayChart()"
        :chart-data="chartDataBar"
        :options="chartOptionsBar"
      />
      <div v-else class="flex-row flex__center" style="height: 100%">
        <i
          class="fas fa-ban color__silver font-size__larger margin-right-10"
        ></i>
        <span class="font-size__medium font-weight__bold opacity-50"
          >Không có dữ liệu
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "../../../constants.js";
import BarChart from "./BarChart.js";
export default {
  name: "mainContent",
  props: ["title", "styleCustom", "dataChart", "type"],
  components: {
    BarChart,
  },

  data() {
    return {
      chartOptionsBar: {
        legend: {
          display: false,
          labels: {
            fontSize: 13,
            fontFamily:
              "'Roboto', sans-serif, 'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial'",
          },
        },
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 13,
                fontFamily:
                  "'Roboto', sans-serif, 'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial'",
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        tooltips: {
          mode: "nearest",
        },
        maintainAspectRatio: false,
        height: 300,
      },
      chartDataBar: {
        labels: [],
        datasets: [
          {
            backgroundColor: ["#41B883", "#8EC7FD", "#F6C85F", "#FFAFAF"],
            data: [],
          },
        ],
      },
    };
  },

  created() {
    this.setDataForChart();
  },
  methods: {
    checkDisplayChart() {
      let check = false;
      if (this.dataChart && this.dataChart.length) {
        this.dataChart.map((item) => {
          if (item) check = true;
        });
      }
      return check;
    },

    setDataForChart() {
      if (this.type === constants.DASHBBOARD_TYPE.VBDEN_CHO_XU_LY) {
        this.chartDataBar.labels = ["Chủ trì", "Phối hợp", "Nhận để biết"];
      }
      if (this.type === constants.DASHBBOARD_TYPE.VBDI_CHO_XU_LY) {
        this.chartDataBar.labels = [
          "Chờ xử lý",
          "Đã xử lý",
          "Phối hợp",
          "Ủy Quyền",
        ];
      }
      this.chartDataBar.datasets[0].data = this.dataChart;
    },
    export2image: function () {
      let canvas = document
        .getElementById(this.title)
        .querySelector("#bar-chart")
        .toDataURL("image/png");
      let link = document.createElement("a");
      link.download = "image";
      link.href = canvas;
      link.click();
    },
    fullScreen() {
      this.$emit("fullScreen", { title: this.title, data: this.chartDataBar });
    },
    viewMore() {},
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/home/components/BarChart.vue